import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

class PressReleaseView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <a
        href={`https://static.squareboard.cloud/assets/press_release/press_release-${this.props.lang}.pdf`}
        className="nav-button--border"
        download
        target="_blank"
        rel="noopener noreferrer"
      >
        {this.props.translations['menu.pressRelease']}
      </a>
    );
  }
}

export default PressReleaseView;
